// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alerting-config>.row[data-v-7568e77e]{padding:10px 0}.alerting-config .banner.info[data-v-7568e77e]{margin-bottom:0;margin-top:0}", ""]);
// Exports
module.exports = exports;
